var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.42 7.95C18.86 10.39 18.86 14.35 16.42 16.79C13.98 19.23 10.02 19.23 7.58 16.79C5.14 14.35 5.14 10.39 7.58 7.95C10.02 5.51 13.98 5.51 16.42 7.95Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.25003 22.39C8.16003 22.39 8.06004 22.37 7.97004 22.34C5.72004 21.44 3.90003 19.85 2.68003 17.75C1.50003 15.7 1.03003 13.38 1.34003 11.02C1.39003 10.61 1.78003 10.32 2.18003 10.37C2.59003 10.42 2.88002 10.8 2.83002 11.21C2.57002 13.23 2.97005 15.23 3.98005 16.99C5.02005 18.79 6.59002 20.16 8.52002 20.93C8.90002 21.09 9.09004 21.52 8.94004 21.91C8.83004 22.21 8.54003 22.39 8.25003 22.39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.8501 5.22998C5.6301 5.22998 5.4101 5.13 5.2601 4.94C5.0001 4.61 5.06011 4.14001 5.39011 3.89001C7.30011 2.40001 9.58009 1.60999 12.0001 1.60999C14.3601 1.60999 16.6101 2.37 18.5001 3.81C18.8301 4.06 18.8901 4.52999 18.6401 4.85999C18.3901 5.18999 17.9201 5.25 17.5901 5C15.9701 3.76 14.0401 3.10999 12.0001 3.10999C9.92009 3.10999 7.95009 3.79001 6.31009 5.07001C6.17009 5.18001 6.0101 5.22998 5.8501 5.22998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.75 22.39C15.45 22.39 15.17 22.21 15.05 21.92C14.9 21.54 15.08 21.1 15.47 20.94C17.4 20.16 18.97 18.8 20.01 17C21.03 15.24 21.43 13.24 21.16 11.22C21.11 10.81 21.4 10.43 21.81 10.38C22.21 10.33 22.6 10.62 22.65 11.03C22.95 13.38 22.49 15.71 21.31 17.76C20.1 19.86 18.27 21.44 16.02 22.35C15.94 22.37 15.85 22.39 15.75 22.39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.dd2f1c4c2dc38aafc470de08917cf8ec.svg";
export { ForwardRef as ReactComponent };